import { InputType } from '@miq/catalog';

/**
 * Ag grid table dictionary between InputType & cell editor name,
 * used to derive
 */
export const InputTypeToCellEditorMap: Map<string, string> = new Map<string, string>([
  [InputType.Dropdown, 'agSelectComponent'],
  [InputType.Number, 'agNumberComponent'],
  [InputType.Text, 'agPopupTextComponent'],
  [InputType.TextArea, 'agPopupTextComponent'],
  [InputType.Date, 'agDateComponent'],
  [InputType.NAICS, 'agNaicsInputComponent'],
  // unsupported ag input types yet
  [InputType.Checkbox, undefined],
  [InputType.Chips, undefined],
  [InputType.StrictChips, undefined],
]);
